import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipBody from '../../shared/TooltipBody';
import TooltipCaption from '../../shared/TooltipCaption';

interface Props {
  stopsCount: number;
}

const OrdersInfoTooltip: React.FC<Props> = ({ stopsCount }) => {
  const { t } = useTranslation('components');
  const title = t('routeDetailsPanel.stats.labels.orders');
  const stopsCountString = t('routeDetailsPanel.stats.labels.stop', { count: stopsCount });

  return (
    <>
      {stopsCount > 0 ? (
        <>
          <TooltipBody text={title} />
          <TooltipCaption text={stopsCountString} />
        </>
      ) : (
        <TooltipBody text={title} />
      )}
    </>
  );
};

export default OrdersInfoTooltip;
